import { Manager, Socket } from 'socket.io-client';

declare global {
  interface Window {
    SOCKET_IO_MANAGER?: Manager;
    SOCKET_IO_NS_MAP?: Map<string, Socket>;
  }
}

const BASE_URL_SOCKET = 'https://demo-tcms.trellisrx.com';

const defaultConfig = {
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 3,
  reconnectionDelay: 1000,
  timeout: 5000,
  forceNew: false,
};

let manager: Manager | null =
  typeof window !== 'undefined' ? window.SOCKET_IO_MANAGER || null : null;

const namespaceToSocket: Map<string, Socket> =
  (typeof window !== 'undefined' && window.SOCKET_IO_NS_MAP) || new Map<string, Socket>();

export function getSocket(namespace: string): Socket {
  if (!manager) {
    manager = new Manager(BASE_URL_SOCKET, defaultConfig);
    if (typeof window !== 'undefined') {
      window.SOCKET_IO_MANAGER = manager;
    }
  }

  const ns = namespace.startsWith('/') ? namespace : `/${namespace}`;
  const existing = namespaceToSocket.get(ns);
  if (existing) return existing;

  const socket = manager.socket(ns);
  namespaceToSocket.set(ns, socket);

  if (typeof window !== 'undefined') {
    window.SOCKET_IO_NS_MAP = namespaceToSocket;
  }

  return socket;
}
